/*
  HACK: This package doesn't allow us skip the buffering of some actions.
  This results in the loading screen not appearing properly on first app load
*/
/* eslint-disable */
var BUFFERED_ACTION_RETURN = 'redux-action-buffer: buffered action'

module.exports = function bufferActions (breaker, ignore, cb) {
  var active = true
  var queue = []
  if (typeof breaker === 'string') {
    var actionType = breaker
    breaker = function (action) {
      if (action.type === actionType) return true
      else return false
    }
  }
  if (Array.isArray(ignore)) {
    skip = function (action) {
      return ignore.indexOf(action.type) > -1
    }
  }

  return function (store) {
    return function (next) {
      return function (action) {
        if (!active) return next(action)
        if (skip(action)) return next(action)
        if (breaker(action)) {
          active = false
          var result = next(action)
          var queueResults = []
          queue.forEach(function (queuedAction) {
            var queuedActionResult = next(queuedAction)
            queueResults.push(queuedActionResult)
          })
          cb && cb(null, {
            results: queueResults,
            queue: queue
          })
          return result
        } else {
          queue.push(action)
          // @TODO consider returning a dummy action, or maybe null for cleanliness
          return BUFFERED_ACTION_RETURN
        }
      }
    }
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./tools/redux-action-buffer/index.js
 ** module id = 1283
 ** module chunks = 1
 **/